import { render, staticRenderFns } from "./CustomTextForm.vue?vue&type=template&id=62dbe62e"
import script from "./CustomTextForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomTextForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports